import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { CareElementOperatorType } from "../CareElementOperatorType";
import { BaseCareElement } from "./BaseCareElement";
import { CareElementType } from "./CareElementType";

export class TextReviewedCareElement extends BaseCareElement {
    public Name: string;
    public Value?: string | null;
    public Target?: string | null;
    public CareElementType: CareElementType.TextReviewed;
    public DateReviewed?: Date | null;
    public LastReviewedDate?: Date | null;
    public Frequency?: CareElementFrequencyType;
    public Operator?: CareElementOperatorType;
    public DateReviewedWithPrecision?: DateTimeWithPrecision | null;

    public constructor(init?: NonFunctionProperties<TextReviewedCareElement>) {
        super();
        this.CareElementType = CareElementType.TextReviewed;
        this.Name = init?.Name ?? "";
        this.Value = init?.Value ?? null;
        this.Target = init?.Target ?? null;
        this.SubSectionName = init?.SubSectionName ?? "";
        this.DateReviewed = init?.DateReviewed ?? null;
        this.LastReviewedDate = init?.LastReviewedDate ?? null;
        this.Frequency = init?.Frequency ?? CareElementFrequencyType.None;
        this.Operator = init?.Operator ?? CareElementOperatorType.None;
        this.DateReviewedWithPrecision = init?.DateReviewedWithPrecision ?? DateTimeWithPrecision.getDate(init?.DateReviewed);
    }
}
